import React, { useState } from "react";
import "./ContactUs.css";
import { FaInstagram, FaLinkedin } from "react-icons/fa";
import { HiOutlineMail, HiOutlineLink } from "react-icons/hi";
import { MdPhone } from "react-icons/md";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ContactUs = () => {
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); 

    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData.entries());

    try {
      await fetch(
        "https://script.google.com/macros/s/AKfycbxvHc3L9tZWIL8UPzpSOvCoRlFHgnJHkgVDrm_-__r71RE4NVEckKXTdN1fgGmlLjK4zg/exec",
        {
          method: "POST",
          mode: "no-cors",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
        }
      );

      toast.success("Message sent successfully!");
      e.target.reset();
    } catch (err) {
      toast.error(" Something went wrong. Please try again.");
    } finally {
      setLoading(false); 
    }
  };

  return (
    <section id="contact" className="contact-section">
      <div className="contact-left">
        <h3 className="contact-title">Contact Us</h3>
        <h2 className="contact-heading">We’d love to hear from you!</h2>
        <p className="contact-subtext">
          For luxury trip planning, hotel collaborations, influencer onboarding,
          or business inquiries – drop us a message and we’ll reach out soon!
        </p>

        {/* Email */}
        <div className="contact-item">
          <div className="contact-icon-box">
            <HiOutlineMail />
          </div>
          <div className="contact-details">
            <h4>Email</h4>
            <a href="mailto:travxplo@gmail.com">travxplo@gmail.com</a>
          </div>
        </div>

        {/* Phone */}
        <div className="contact-item">
          <div className="contact-icon-box">
            <MdPhone />
          </div>
          <div className="contact-details">
            <h4>Phone</h4>
            <a href="tel:+919209679072">+91 92096 79072</a>
          </div>
        </div>

        {/* Social */}
        <div className="contact-item">
          <div className="contact-icon-box">
            <HiOutlineLink />
          </div>
          <div className="contact-details">
            <h4>Social Media</h4>
            <div className="contact-info-icons">
              <a
                href="https://www.instagram.com/travxplo"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram style={{ color: "#E1306C" }} />
              </a>
              <a
                href="https://www.linkedin.com/company/travxplo-ltd/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLinkedin style={{ color: "#0077B5" }} />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Contact Form Details*/}
      <form className="contact-right contact-form" onSubmit={handleSubmit}>
        <h3>Send Message</h3>
        <input type="text" name="name" placeholder="Full Name" required />
        <input type="email" name="email" placeholder="Email" required />
        <textarea
          name="message"
          placeholder="Type your Message..."
          required
          rows="4"
        ></textarea>
        <select name="iam">
          <option value="">I am a...</option>
          <option value="traveler">Traveler</option>
          <option value="hotel">Hotel/Resort</option>
          <option value="influencer">Influencer</option>
          <option value="investor">Investor</option>
          <option value="other">Other</option>
        </select>
        <button
          type="submit"
          className="contact-form-button"
          disabled={loading}
          style={{
            opacity: loading ? 0.6 : 1,
            cursor: loading ? "not-allowed" : "pointer",
          }}
        >
          {loading ? "Sending..." : "Send"}
        </button>
      </form>

      {/* Toast notifications */}
      <ToastContainer position="bottom-right" autoClose={3000} />
    </section>
  );
};

export default ContactUs;
